import 'flatpickr';

var tablesort = require('tablesort');

(function(){
    'use strict';
    
    /**
     * ===================================================
     * Form helpers
     * Add the following code if you want the name of the file appear on select
     * ===================================================
     */
    $('.sq-form-upload input').on('change', function() {

        var fileName = $(this).val().split('\\').pop();

        $(this).closest('.sq-form-question').find('.sq-form-question-title').addClass('selected').html(fileName);
    });


    /**
     * ===================================================
     * Form helpers
     * https://getbootstrap.com/docs/4.3/components/forms/#checkboxes
     * ===================================================
     */
    $('.sq-form-question-answer').each(function() {

        var $checkOrRadio = $(this);

        if( $($checkOrRadio).find(':radio').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-radio"></div>');
        }

        if( $($checkOrRadio).find(':checkbox').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-checkbox"></div>');
        }
    });

    var config = {
        enableTime: true,
        dateFormat: "d M Y h:i K",
    }

    if($('.datepicker input[type=text]').length) {
        $('.datepicker input[type=text]').flatpickr(config);
    }

    if (document.querySelectorAll('table.sort').length) {
        var table = document.querySelectorAll('table.sort');
        for (var i = 0; i < table.length; i++){
            tablesort(table[i]);
        }
    }
}());
